import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import WhatsAppFab from "../components/WhatsAppFab";
import Packages from "../components/Packages";
import Testimonials from "../components/Testimonials";

export default function PackagesPage() {
  return (
    <div
      data-testid="packages-page-root"
      className="min-h-screen bg-[#F4F3ED] text-[#0A0A0A] font-body"
    >
      <Navbar />
      <main className="pt-28 lg:pt-32">
        <div className="px-5 lg:px-10 max-w-[1320px] mx-auto mb-2">
          <div className="font-mono-acc text-[10px] tracking-[0.3em] uppercase text-[#D9381E]">
            <Link to="/" className="hover:text-[#0A0A0A]">
              Home
            </Link>{" "}
            / Packages
          </div>
        </div>
        <Packages />

        {/* Syllabus download strip */}
        <section
          data-testid="packages-syllabus-strip"
          className="px-5 lg:px-10 max-w-[1320px] mx-auto py-6 lg:py-8"
        >
          <div className="border border-[#0A0A0A] bg-[#EAE8DF] p-6 lg:p-7 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <div>
              <div className="font-mono-acc text-[10px] tracking-[0.3em] uppercase text-[#D9381E] mb-1">
                Not sure which tier?
              </div>
              <div className="font-display font-black text-xl lg:text-2xl tracking-tight">
                Read the full syllabus first.
              </div>
              <p className="font-body text-sm text-[#4A4A4A] mt-1">
                Complete Phase 1 curriculum + Phase 2 mastery breakdown, all
                12 modules — takes 5 minutes to skim.
              </p>
            </div>
            <a
              href="/downloads/GreatEagle_Syllabus.pdf"
              download
              data-testid="packages-syllabus-download"
              className="inline-flex items-center justify-center gap-2 bg-[#0A0A0A] text-[#F4F3ED] px-6 py-3.5 font-body text-sm uppercase tracking-[0.22em] hover:bg-[#D9381E] transition-colors whitespace-nowrap"
            >
              ↓ Download Syllabus PDF
            </a>
          </div>
        </section>

        <Testimonials />
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}
